import { useTranslation } from "react-i18next";
import { IconNotFound } from "../../../../../common/icons/IconNotFound/IconNotFound";
import { IconRefresh } from "../../../../../common/icons/IconRefresh/IconRefresh";
import defaultContent from "../../../../../content/groupManagement";
import "./ActionCardError.scss";

type ActionCardErrorProps = {
  onRetry: () => void;
};

export const ActionCardError = ({ onRetry }: ActionCardErrorProps) => {
  const { t } = useTranslation(["groupManagement"]);

  return (
    <button className="action-card-error" onClick={onRetry}>
      <IconNotFound />
      <div className="action-card-error__content">
        <p className="action-card-error__message">{t("errorMessage", defaultContent.errorMessage)}</p>
        <div className="action-card-error__retry">
          <IconRefresh color="blue" />
          <div className="action-card-error__retry-label">
            <span>{t("tryAgain", defaultContent.tryAgain)}</span>
          </div>
        </div>
      </div>
    </button>
  );
};
